import {
  FULL_SERVICE, GLOBAL_CATALOGS,
} from '../../types';

const initialState = {
  user: {},
  tabs: [],
  isLoading: false,
  value: GLOBAL_CATALOGS.Postal.Announcement.List,
  announcement: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  mail: {
    isLoading: true,
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  details: {},
};

const postalReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_SERVICE.Postal.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_SERVICE.Postal.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    case GLOBAL_CATALOGS.Postal.Service: {
      return {
        ...state,
        tabs: action.payload
      };
    }
    case GLOBAL_CATALOGS.Postal.Announcement.List: {
      return {
        ...state,
        announcement: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Postal.Mail.List: {
      return {
        ...state,
        mail: { ...action.payload }
      };
    }
    case FULL_SERVICE.Postal.User: {
      return {
        ...state,
        user: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default postalReducer;
